<template>
  <v-container class="container">
    <v-row>
      <FilterAct :title="titleAct" />
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" xs="4">
        <v-card class="mx-2">
          <v-card-title
            style="background-color: #82a1d0; height: 52px"
            class="d-flex justify-space-between"
          >
            <div class="container__btns" style="margin-top: -8px">
              <v-menu
                v-model="btnConfigTable.menu"
                :close-on-content-click="false"
                nudge-width="250px"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        @click="openMenu"
                        v-bind="attrs"
                        v-on="on"
                        class="mr-5"
                      >
                        <v-icon>{{ btnConfigTable.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ btnConfigTable.tooltip }}</span>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-card-title class="d-flex align-center ma-0 pa-0 pa-1">
                    <!-- Buscador -->
                    <v-text-field
                      v-model="search"
                      label="Buscar columna..."
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-card-title>

                  <div
                    style="
                      max-height: 250px;
                      overflow-y: auto;
                      scrollbar-width: unset;
                    "
                  >
                    <v-list dense class="mt-n2 ml-n3 pa-0 ma-0">
                      <v-list-item
                        v-for="(column, index) in filteredColumns"
                        :key="column.colName"
                        draggable="true"
                        @dragstart="startDrag(index)"
                        @dragover.prevent
                        @drop="onDrop(index)"
                        class="d-flex align-center"
                      >
                        <!-- Ícono de arrastre -->
                        <v-icon>mdi-drag</v-icon>

                        <!-- Checkbox -->
                        <v-checkbox
                          v-model="column.checked"
                          :order="column.order"
                          @change="checkboxChange"
                          dense
                          hide-details
                        ></v-checkbox>

                        <!-- Nombre de la columna -->
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ column.colLabel }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card>
              </v-menu>

              <v-text-field
                style="max-width: 400px"
                dense
                solo
                v-model="search"
                append-icon="mdi-magnify"
                :label="$tc('commons.search')"
                single-line
                hide-details
                class="search"
              ></v-text-field>
            </div>
            <div class="container__btns" style="margin-top: -9px">
              <div v-for="item in itemsActions" :key="item.name">
                <v-tooltip bottom v-if="item.asegurable">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="item.disabled"
                      class="btn__actions mr-1"
                      small
                      :color="item.color"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="item.function()"
                    >
                      <v-icon small>{{ item.icon }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-card-title>
          <DataTable
            :search="search"
            :headers="dynamicHeaders"
            :openDeprecated="openDeprecated"
            :openApproved="openApproved"
            :openFiles="openFiles"
            :openAction="openUndo"
            :items="getActivities"
            :title="titleFiles"
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" xs="12" md="12">
        <v-dialog v-model="showTimeDetail" max-width="550px" persistent>
          <v-card
            max-width="550px"
            max-height="650px"
            style="overflow-y: scroll; scrollbar-width: unset"
          >
            <v-card-title style="display: flex; justify-content: center">
              {{ $tc("workflow.hoursDetails") }}
            </v-card-title>
            <v-alert
              dense
              v-if="error"
              color="orange"
              elevation="5"
              outlined
              text
              type="error"
              align="left"
              class="d-flex align-center mx-5"
              style="white-space: pre-line"
            >
              {{
                alertValidate
                  .map((text) => text.replace(/\.• /gu, ".\n$1"))
                  .join("\n")
              }}
            </v-alert>
            <v-card-actions class="d-flex flex-column justify-center mb-0 pb-0">
              <div class="d-flex" style="max-width: 500px">
                <v-text-field
                  v-model="data.process"
                  disabled
                  rounded
                  filled
                  :label="$tc('workflow.process')"
                />
                <v-text-field
                  v-model="data.tipoProceso"
                  disabled
                  rounded
                  filled
                  :label="$tc('workflow.processType')"
                />
              </div>
              <div style="max-width: 500px" class="d-flex">
                <v-text-field
                  v-model="data.date"
                  disabled
                  rounded
                  filled
                  :label="$tc('workflow.inTheDate')"
                />
                <v-text-field
                  v-model="data.employees"
                  disabled
                  rounded
                  filled
                  :label="$tc('workflow.employees')"
                />
              </div>
            </v-card-actions>
            <div class="mx-5">
              <v-text-field
                v-model="data.cantLiq"
                disabled
                rounded
                filled
                :label="$tc('workflow.liquidatedHours')"
              />
            </div>
            <v-card-actions class="d-flex flex-column justify-center mb-0 py-0">
              <div style="display: flex; max-width: 500px">
                <v-menu
                  ref="menuAut"
                  v-model="menuAut"
                  offset-y
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.cantAut"
                      :label="$tc('information.authorizedAmount')"
                      rounded
                      filled
                      v-bind="attrs"
                      v-on="on"
                      @change="updateCantNoAut"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="data.cantAut"
                    scrollable
                    format="24hr"
                    :max="data.cantLiq"
                  >
                    <v-btn
                      text
                      color="primary"
                      @click="menuAut = false"
                      class="v-picker__actions"
                    >
                      {{ $tc("commons.accept") }}
                    </v-btn>
                  </v-time-picker>
                </v-menu>
                <v-menu
                  ref="cantCC"
                  v-model="cantCC"
                  offset-y
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.cantCC"
                      :label="$tc('information.cantCC')"
                      rounded
                      filled
                      v-bind="attrs"
                      v-on="on"
                      class=""
                    ></v-text-field>
                  </template>
                  <v-time-picker v-model="data.cantCC" scrollable format="24hr">
                    <!-- :max="data.cantLiq" -->
                    <v-btn
                      text
                      color="primary"
                      @click="cantCC = false"
                      class="v-picker__actions"
                    >
                      {{ $tc("commons.accept") }}
                    </v-btn>
                  </v-time-picker>
                </v-menu>
                <v-menu
                  ref="menuNo"
                  v-model="menuNo"
                  offset-y
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.cantNoAut"
                      :label="$tc('information.unauthorizedAmount')"
                      rounded
                      filled
                      v-bind="attrs"
                      v-on="on"
                      class=""
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="data.cantNoAut"
                    scrollable
                    format="24hr"
                    :max="data.cantLiq"
                  >
                    <v-btn
                      text
                      color="primary"
                      @click="menuNo = false"
                      class="v-picker__actions"
                    >
                      {{ $tc("commons.accept") }}
                    </v-btn>
                  </v-time-picker>
                </v-menu>
              </div>
            </v-card-actions>
            <div>
              <v-switch
                v-model="isFreeComment"
                label="Comentario libre"
                inset
                class="mx-8 mt-0 mb-2 pa-0"
                hide-details
              />
              <v-combobox
                v-if="!isFreeComment"
                rounded
                filled
                v-model="selectedComent"
                :items="getComents"
                label="Comentario"
                item-text="comentario"
                item-value="comentario"
                hide-details
                class="mb-6 mx-6"
              />
              <v-textarea
                v-else
                v-model="coment"
                label="Escribe tu comentario"
                outlined
                :rules="[rules, maxCharRule]"
                counter="250"
                class="mx-6"
              />
            </div>
            <div class="d-flex justify-space-between mx-6 pb-6">
              <v-btn class="bt-exit" @click="cancel">{{
                $tc("editRegistrations.cancel")
              }}</v-btn>
              <v-btn
                class="bt-acept"
                @click="changeValues"
                :disabled="
                  (isFreeComment && (!coment || coment.length > 250)) ||
                  (!isFreeComment && !selectedComent)
                "
                >{{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showSeeFiles"
      persistent
      @keydown.esc="closeDialogFiles()"
    >
      <v-card tile>
        <v-toolbar flat dark color="primary">
          <v-btn icon dark @click="closeDialogFiles()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h3 class="secondary--text">{{ titleFiles }}</h3>
          </v-toolbar-title>
        </v-toolbar>
        <TableWithSearch
          :items="getFiles"
          :headers="allHeaders"
          :openDialog="openDialog"
          :showPagination="false"
          :showAdd="false"
          :showDelete="false"
          :showEdit="false"
          :showFiles="true"
          @headersUpdated="updateHeaders"
          class="pa-4"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDocs"
      scrollable
      persistent
      :fullscreen="isPdf"
      max-width="60%"
      class="mx-auto"
      @keydown.esc="closeDialog()"
    >
      <v-card>
        <v-card-text max-height="900px" class="pt-4">
          <!-- Mostrar PDF -->
          <template v-if="isPdf">
            <iframe :src="fileSrc" frameborder="0" class="file-viewer"></iframe>
          </template>
          <!-- Mostrar Imagen -->
          <template v-else-if="isImage">
            <div class="file-viewer">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :href="fileSrc"
                    :download="`archivo.${fileExtension}`"
                    class="primary"
                    small
                  >
                    <v-icon dark>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Descargar imagen</span>
              </v-tooltip>
              <img :src="fileSrc" alt="file image" class="file-viewer" />
            </div>
          </template>
          <!-- Proponer descarga si no es PDF ni Imagen -->
          <template v-else>
            <p>
              Este archivo no se puede previsualizar. Haga clic en el botón de
              abajo para descargarlo.
            </p>
            <v-btn
              :href="fileSrc"
              :download="`archivo.${fileExtension}`"
              dense
              small
              class="primary"
            >
              Descargar archivo
              <v-icon right dark> mdi-download </v-icon>
            </v-btn>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-center">
          <v-btn class="bt-exit" @click="closeDialog()">
            {{ $tc("commons.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showLicense" max-width="525px">
      <Form
        @save="saveFormLic"
        @cancel="reset"
        :maxWidth="'525px'"
        :mode="mode"
        :show="true"
        :itemsSelect="dataLic"
        :showDate="true"
        :itemsHours="hoursArray"
        @select-updated="itemUpdated"
        :uploadFiles="true"
      >
      </Form>
    </v-dialog>
    <v-dialog v-model="showSchedule" max-width="550px">
      <ChangeSchedule
        @save="saveFormScheudle"
        @cancel="cancelForm"
        :formSubmitted="formSubmitted"
        max-width="550px"
      />
    </v-dialog>
    <v-dialog v-model="showDelegation" max-width="550px">
      <ChangeDelegation
        @save="saveFormDelegation"
        @cancel="cancelForm"
        :formSubmitted="formSubmitted"
        max-width="550px"
      />
    </v-dialog>
    <v-dialog v-model="showDialogComent" max-width="550px" persistent>
      <v-col class="ma-0 pa-0">
        <v-card class="px-2 pt-2">
          <v-alert dense outlined type="error" class="text-center">
            Esta operación podría causar que se supere el tope máximo o mínimo
            de una Cuenta Corriente
          </v-alert>
          <v-card-title> Agregar comentario </v-card-title>
          <v-card-text>Solo para autorizaciones de horas extras.</v-card-text>
          <div>
            <v-switch
              v-model="isFreeComment"
              label="Comentario libre"
              inset
              class="px-4"
            />
            <v-combobox
              v-if="!isFreeComment"
              rounded
              filled
              v-model="selectedComent"
              :items="getComents"
              label="Comentario"
              item-text="comentario"
              item-value="comentario"
              hide-details
              class="mb-3 px-2"
            />
            <v-textarea
              v-else
              v-model="coment"
              label="Escribe tu comentario"
              outlined
              :rules="[rules, maxCharRule]"
              counter="250"
              class="px-2"
            />
          </div>
          <div class="d-flex justify-space-between pa-4">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn
              class="bt-acept"
              @click="continueComent"
              :disabled="
                (isFreeComment && (!coment || coment.length > 250)) ||
                (!isFreeComment && !selectedComent)
              "
              >{{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-dialog>
    <v-dialog
      v-model="alertValidateCurrent"
      max-width="500"
      @keydown.esc="cancelValidate()"
      @keydown.enter="handleAccept()"
      persistent
    >
      <v-card>
        <v-card-title class="px-2 py-2">
          <v-alert
            dense
            outlined
            type="error"
            class="left"
            style="white-space: pre-line"
          >
            {{ messageAlertValidate.join("\n") }}
          </v-alert>
        </v-card-title>
        <v-card-actions class="d-flex justify-space-between mt-n4">
          <v-btn class="bt-exit large" @click="cancelValidate()">{{
            $tc("commons.cancel")
          }}</v-btn>
          <v-btn class="bt-acept large" @click="handleAccept()">{{
            $tc("commons.accept")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Alerts :alert="alert" :color="color" :textAlert="textAlert" />
  </v-container>
</template>

<script>
import date from "../../../store/common/date";
import DataTable from "../commons/DataTable.vue";
import ToolbarTitles from "../../Complement/ToolbarTitles.vue";
import DateNotCheck from "../commons/DateNotCheck.vue";
import activities from "../../../store/workflow/activities";
import FilterAct from "./FilterAct.vue";
import moment from "moment";
import attributes from "../../../store/workflow/attributes";
import Loader from "../../Complement/Loader.vue";
import Alerts from "../../GestionEmpleados/commons/Alerts.vue";
import employeesW from "../../../store/workflow/employeesW";
import schedules from "../../../store/workflow/schedule";
import ChangeSchedule from "./ChangeSchedule.vue";
import registrations from "../../../store/gestionTiempos/registrations";
import dates from "../../../store/common/date";
import Form from "../../Complement/Form.vue";
import delegations from "../../../store/workflow/delegations";
import ChangeDelegation from "./ChangeDelegation.vue";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Form,
    ChangeSchedule,
    ToolbarTitles,
    DateNotCheck,
    DataTable,
    FilterAct,
    Loader,
    Alerts,
    ChangeDelegation,
    TableWithSearch,
  },
  data() {
    return {
      draggingIndex: null,
      titleFiles: "Documentos adjuntos",
      titleAct: this.$tc("workflow.activityTray"),
      search: "",
      mode: "Pedido de Licencia",
      authorizedData: null,
      titleSchedule: "Cambio de horario",
      noAuthoData: null,
      showSchedule: false,
      showDelegation: false,
      showSeeFiles: false,
      showDocs: false,
      fileBase64: "",
      menuNo: false,
      cantCC: false,
      menuAut: false,
      showLicense: false,
      isLoading: true,
      textAlert: "",
      error: false,
      color: "",
      alert: false,
      alertValidate: [],
      cantLiq: null,
      showTimeDetail: false,
      showUndo: false,
      btnConfigTable: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      checkedItems: new Array(20).fill(false),
      data: {
        cantCC: 0,
        cantNoAut: 0,
        cantAut: 0,
        process: "",
        tipoProceso: "",
        date: "",
        employees: "",
        cantLiq: 0,
        movimId: null,
        approved: null,
      },
      filter: {},
      selected: [],
      flagApproved: false,
      operAutho: false,
      formSubmitted: false,
      selectedComent: null,
      isFreeComment: false,
      coment: "",
      alertValidateCurrent: false,
      messageAlertValidate: [],
      payloadToSave: null,
      rules: [(v) => !!v || "Este campo es obligatorio"], // Regla común de validación
      maxCharRule: (v) => v.length <= 250 || "Máximo 250 caracteres", // Regla de máximo 250 caracteres
      showDialogComent: false,
      alertCurrentAccoun: false,
      headersFiles: [
        {
          text: "Comentario",
          value: "coment",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha",
          value: "date",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      hoursArray: [
        {
          name: "timeFrom",
          label: "Hora desde",
          data: "00:00",
          show: false,
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        {
          name: "timeTo",
          label: "Hora hasta",
          data: "00:00",
          show: false,
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],
    };
  },
  created() {
    activities.commit("setActivities", []);
    Promise.all([
      activities.dispatch("getFilter"),
      attributes.dispatch("getAttributes"),
      delegations.dispatch("getIsShowDelegation"),
      activities.dispatch("getComents"),
    ])
      .then(() => {
        this.isLoading = false;
        if (this.getComents.length > 0) {
          this.selectedComent = this.getComents[0];
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.isLoading = false;
      });
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleFiles;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    fileSrc() {
      return this.fileBase64; // El string base64 completo (data:image/jpeg;base64,...)
    },
    fileExtension() {
      const matches = this.fileBase64.match(/^data:(.+?);base64,/);
      return matches ? matches[1].split("/")[1] : "archivo"; // Obtenemos solo la extensión
    },
    isPdf() {
      return this.fileBase64.startsWith("data:application/pdf"); // Detectar si es PDF
    },
    isImage() {
      return this.fileBase64.startsWith("data:image/"); // Detectar si es una imagen
    },
    getActivities() {
      return activities.state.activities;
    },
    getFilter() {
      return activities.state.filter;
    },
    getFiles() {
      return activities.state?.filesAct;
    },
    visibleColumnas() {
      return activities.state.filter?.columnas
        ?.filter((item) => item.visible) // Filtra solo las visibles
        .sort((a, b) => a.order - b.order); // Ordena por order
    },
    filteredColumns() {
      if (!this.search) return this.visibleColumnas; // Si no hay búsqueda, devuelve todas
      return this.visibleColumnas.filter((column) =>
        column.colLabel.toLowerCase().includes(this.search.toLowerCase()),
      );
    },
    dynamicHeaders() {
      const checkedColumns =
        this.getFilter.columnas?.filter((column) => column.checked) || [];

      const getWidthByTextLength = (text) => {
        const length = text.length;
        if (length <= 4) return "80px";
        if (length <= 7) return "100px";
        if (length <= 10) return "130px";
        return "150px";
      };

      const headers = checkedColumns.map((column) => ({
        text: column.colLabel,
        value: column.colName,
        class: "primary secondary--text",
        sortable: true,
        width: getWidthByTextLength(column.colLabel),
      }));

      headers.unshift({
        text: "Acciones",
        value: "actions",
        class: "primary secondary--text",
        sortable: false,
        width: "100px",
      });

      return headers;
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },
    pendings() {
      return activities.state.changeEvent;
    },
    itemsActions() {
      const asegurables = JSON.parse(localStorage.getItem("asegurables")) || [];
      const isAsegurable = (accion) => asegurables.includes(accion);
      return [
        {
          name: this.$tc("workflow.licenseRequests"),
          icon: "fa-stamp",
          function: this.goToLic,
          color: "#718294",
          disabled: false,
          asegurable: isAsegurable("accion:pedidolicencia"),
        },
        {
          name: this.$tc("workflow.scheduleChange"),
          icon: "fa-clock",
          function: this.goToSchedules,
          color: "#718294",
          disabled: false,
          asegurable: isAsegurable("accion:pedidocambiohorario"),
        },
        {
          name: this.$tc("workflow.delegate"),
          icon: "fa-network-wired",
          function: this.goToDelegation,
          color: "#718294",
          disabled: this.showDelegationOperId,
          asegurable: isAsegurable("accion:pedidodelegacion"),
        },
        {
          name: this.$tc("workflow.approved"),
          icon: "fa-thumbs-up",
          function: this.goToApprove,
          color: "#39537a",
          disabled: !this.pendings,
          asegurable: true,
        },
        {
          name: this.$tc("workflow.reject"),
          icon: "fa-thumbs-down",
          function: this.goToReject,
          color: "#39537a",
          disabled: !this.pendings,
          asegurable: true,
        },
        {
          name: this.$tc("workflow.undo"),
          icon: "fa-arrow-left",
          function: this.goToUndo,
          color: "#39537a",
          disabled: this.pendings,
          asegurable: true,
        },
      ];
    },

    getSchedules() {
      return schedules.state.schedules;
    },
    showDelegationOperId() {
      return !delegations.state.isShowDelegation;
    },
    showAct() {
      const operId = parseInt(localStorage.getItem("operId"));
      const authorizedOperIds = this.authorizedOperators.map(
        (operator) => operator.operId,
      );
      return !authorizedOperIds.includes(operId);
    },
    authorizedOperators() {
      const operators = attributes.state.attributes.reduce(function (
        acc,
        item,
      ) {
        if (item.level >= 0) {
          return Math.min(acc, item.level);
        } else {
          return acc;
        }
      },
      Infinity);
      this.operAutho = attributes.state.attributes.filter(
        (e) => e.level == operators,
      );
      return this.operAutho;
    },
    dataLic() {
      return [
        {
          name: "emp",
          label: "Empleado",
          data: "",
          items: this.getEmployees,
          itemsValue: "empId",
          itemsText: "employee",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        {
          name: "concept",
          label: "Concepto",
          data: "",
          items: this.getConcept,
          itemsValue: "id",
          itemsText: "name",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        {
          name: "costo",
          label: "Centro de Costo",
          data: "",
          items: this.getCost,
          itemsValue: "id",
          itemsText: "name",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ];
    },
    getEmployees() {
      return activities.state.employees;
    },
    getConcept() {
      return activities.state.licenseConcepts;
    },
    getCost() {
      return registrations.state.csCosts;
    },
    getComents() {
      return activities.state.coments;
    },
  },
  methods: {
    itemUpdated(item) {
      if (item.name === "concept" && item.data != null) {
        const conceptSelected = item.items.find((i) => i.id === item.data);
        if (!conceptSelected) return;
        const showHours = conceptSelected.licTot === "N";
        this.hoursArray.forEach((hour) => {
          hour.show = showHours;
        });
      }
    },
    resetColumnsOrder() {
      configTable.state.colums = [...this.headersFiles];
      this.saveConfigColumns();
    },
    openMenu() {
      this.btnConfigTable.menu = !this.btnConfigTable.menu;
    },
    startDrag(index) {
      this.draggingIndex = index;
    },
    onDrop(index) {
      if (this.draggingIndex !== null) {
        const movedItem = this.visibleColumnas.splice(this.draggingIndex, 1)[0];
        this.visibleColumnas.splice(index, 0, movedItem);

        // Actualiza el order después del cambio
        this.visibleColumnas.forEach((item, i) => {
          item.order = i;
        });

        this.draggingIndex = null;
        this.goToRefresh();
      }
    },
    dispatchColumnOrder() {
      activities.commit("updateColumnOrder", this.columns);
      activities.dispatch("saveColumnOrder").then(() => {
        this.goToRefresh();
      });
    },
    checkboxChange() {
      this.goToRefresh();
    },
    goToRefresh() {
      let filter = {
        ...activities.state.filter,
        to:
          activities.state.checkTo == true ? null : activities.state.filter.to,
        checkTo: activities.state.checkTo,
      };

      filter.mine = filter.mine === "true";
      filter.pendings = filter.pendings === "true";

      this.isLoading = true;
      activities.commit("setEditFilter", filter);
      activities
        .dispatch("editFilter")
        .then(async () => {
          await activities.dispatch("getActivities").then(() => {
            if (activities.state.activities.length == 0) {
              this.alert = true;
              this.color = "#FF8D58";
              this.textAlert = this.$tc("workflow.noActivities");
            }
          });
          setTimeout(() => {
            this.alert = false;
          }, 5000);

          this.isLoading = false;
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = "Error al guardar el filtro";
          this.isLoading = false;
        });
    },
    initializeData() {
      activities.commit("setActivities", []);
      activities.dispatch("getFilter");
      attributes.dispatch("getAttributes").then(() => {
        this.isLoading = false;
      });
    },
    goToLic() {
      dates.state.dateTo = moment().format("YYYY-MM-DD");
      dates.state.checkTo = false;
      this.isLoading = true;
      activities.dispatch("getLicenseConcepts");
      registrations.dispatch("getCsCost");
      activities.dispatch("getEmployees").then(() => {
        this.isLoading = false;
        this.showLicense = true;
      });
    },
    goToSchedules() {
      this.isLoading = true;
      employeesW.dispatch("getEmployees", false).then(() => {
        this.isLoading = false;
        this.showSchedule = true;
      });
      schedules.dispatch("getSchedules");
    },
    goToDelegation() {
      this.isLoading = true;
      delegations.dispatch("getAvaibleOperators").then(() => {
        this.isLoading = false;
        this.showDelegation = true;
      });
      schedules.dispatch("getSchedules");
    },
    goToApprove() {
      if (this.validateItemsEmty()) {
        this.flagApproved = true;
        this.approvedAll();
      }
    },
    goToReject() {
      if (this.validateItemsEmty()) {
        this.flagApproved = false;
        this.approvedAll();
      }
    },
    validateItemsEmty() {
      if (activities.state.itemsSelected.length == 0) {
        this.alert = true;
        this.color = "#FF8D58";
        this.textAlert = this.$tc("workflow.seleccion");
        setTimeout(() => {
          this.alert = false;
        }, 5000);
        return false;
      }
      return true;
    },
    saveFormLic(item) {
      this.isLoading = true;
      let payload = {
        ...item,
        from: date.state.dateFrom,
        to: date.state.dateTo,
      };
      activities.commit("setNewLicAct", payload);
      activities
        .dispatch("newLicAct")
        .then(() => {
          this.alert = true;
          this.color = "#909DFA";
          this.isLoading = false;
          this.textAlert = this.$tc("workflow.changeLic");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
          this.isLoading = false;
          console.log(e);
        });
      this.reset();
    },
    saveFormScheudle(item) {
      this.isLoading = true;
      activities.commit("setNewScheduleAct", item);
      activities
        .dispatch("newScheduleAct")
        .then(() => {
          this.alert = true;
          this.color = "#909DFA";
          this.isLoading = false;
          this.textAlert = this.$tc("workflow.changeScheduleAlert");
        })
        .catch((e) => {
          console.log(e);
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
          this.isLoading = false;
        });
      this.formSubmitted = true;
      setTimeout(() => {
        this.formSubmitted = false;
        this.alert = false;
      }, 10000);

      this.cancelForm();
    },
    saveFormDelegation(item) {
      this.isLoading = true;
      delegations.commit("setNew", item);
      delegations
        .dispatch("newDelegation")
        .then(() => {
          this.alert = true;
          this.color = "#909DFA";
          this.isLoading = false;
          this.textAlert = this.$tc("workflow.changeScheduleAlert");
        })
        .catch((e) => {
          console.log(e);
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
          this.isLoading = false;
        });
      this.formSubmitted = true;
      setTimeout(() => {
        this.formSubmitted = false;
        this.alert = false;
      }, 10000);

      this.cancelForm();
    },
    cancelForm(item) {
      this.showSchedule = false;
      this.showDelegation = false;
      this.resetDate();
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },
    reset() {
      this.dataLic.forEach((item) => {
        item.data = "";
      });

      this.showLicense = false;
      this.resetDate();
    },
    goToUndo() {
      if (this.validateItemsEmty()) {
        this.allUndo();
      }
    },
    async openApproved(item) {
      this.data = {
        cantCC: "00:00",
        cantNoAut: item.cantNoAut,
        cantAut: item.cantAut,
        process: item.proceso,
        tipoProceso: this.changeType(item.tipoProceso),
        date: item.enLaFecha,
        employees: item.empleado,
        cantLiq: item.cantLiq,
        movimId: parseInt(item.movimId, 10),
        approved: 1,
      };

      // Extraer empId
      const empId = item.empleado.match(/\((\d+)\)/)?.[1];

      // Seleccionar la fecha basada en el tipo de proceso
      let fechaSeleccionada;
      if (this.data.tipoProceso === "HSEX") {
        fechaSeleccionada = item.fechaLiq;
      } else if (this.data.tipoProceso === "LICE") {
        fechaSeleccionada = item.desde;
      } else {
        // Si no es HSEX o LICE, proceder directamente
        this.finalizeProcess(item);
        return;
      }

      const fechaLiq = moment(fechaSeleccionada, "DD-MM-YYYY").format(
        "YYYY-MM-DD",
      );

      // Crear el payload para el GET
      const payload = {
        empId: empId,
        fecha: fechaLiq,
        conceptoId: item.conceptoId,
      };

      // Realizar el dispatch con el payload ajustado
      await registrations.dispatch("getCurrentAccount", payload);
      const currentAccounts = registrations.state.currentAccount;
      // Verificar currentAccount y fecha
      if (
        !currentAccounts ||
        currentAccounts === undefined ||
        currentAccounts.length === 0 ||
        !fechaSeleccionada
      ) {
        this.finalizeProcess(item);
      } else {
        let isValid = true;

        for (const account of currentAccounts) {
          if (this.data.tipoProceso === "HSEX") {
            const valid = this.validateHSEX(account, item);
            if (!valid) isValid = false; // No detiene el flujo, pero marca como inválido
          } else if (this.data.tipoProceso === "LICE") {
            const valid = this.validateLICE(account, item);
            if (!valid) isValid = false; // No detiene el flujo, pero marca como inválido
          }
        }

        // Si alguna validación falla, detener el proceso
        if (!isValid) {
          console.error(
            "Validación fallida en una de las cuentas. No se puede proceder con la aprobación.",
          );
          return;
        }

        this.finalizeProcess(item);
      }
    },

    // Función para manejar el flujo final cuando no hay datos adicionales
    finalizeProcess(item) {
      if (item.tipoProceso === "Autorizacíon de extras") {
        this.showTimeDetail = true;
      } else {
        this.changeValues();
      }
    },

    validateHSEX(currentAccount, item) {
      try {
        const totalMinutes = moment.duration(item.cantAut).asMinutes();
        const matchedConcept = currentAccount.conceptos.find(
          (concepto) =>
            concepto.conceptoId === item.conceptoId &&
            concepto.csCostoId === item.csCostoId,
        );
        if (!matchedConcept) {
          return false;
        }
        this.error = true;
        this.alertValidate.push(
          `• El saldo de la cuenta ${currentAccount.nomCuenta} es: ${currentAccount.saldo} minutos.`,
        );
        const { paramA = 0, paramB = 0, debCred } = matchedConcept;
        const saldoCalculadoConParametros = paramA + paramB * totalMinutes;
        let saldoFinal =
          debCred === "C"
            ? currentAccount.saldo + saldoCalculadoConParametros
            : currentAccount.saldo - saldoCalculadoConParametros;

        if (debCred === "C" && saldoFinal > currentAccount.topeMax) {
          this.alertValidateCurrent = true;
          this.messageAlertValidate.push(
            `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y excede el límite máximo permitido de ${currentAccount.topeMax}.`,
          );
          this.payloadToSave = item;
          return false;
        } else if (debCred === "D" && saldoFinal < currentAccount.topeMin) {
          this.alertValidateCurrent = true;
          this.messageAlertValidate.push(
            `•El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y está por debajo del límite mínimo permitido de ${currentAccount.topeMin}.`,
          );
          this.payloadToSave = item;
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    validateLICE(currentAccount, licencia) {
      try {
        const startDate = moment(licencia.desde, "DD-MM-YYYY").startOf("day");
        const endDate = moment(licencia.hasta, "DD-MM-YYYY").startOf("day");
        const matchedConcept = currentAccount.conceptos.find(
          (concepto) =>
            concepto.conceptoId === licencia.conceptoId &&
            concepto.csCostoId === licencia.csCostoId,
        );

        if (!matchedConcept) {
          return false;
        }
        const { paramA = 0, paramB = 0, debCred } = matchedConcept;
        let duration, saldoCalculado;
        if (licencia.licTot === "S") {
          duration = endDate.diff(startDate, "days");
          saldoCalculado = paramA + paramB * duration;
        } else {
          const hours = endDate.diff(startDate, "hours");
          saldoCalculado = paramA + paramB * hours;
        }

        // Calculamos el saldo final
        let saldoFinal =
          debCred === "C"
            ? currentAccount.saldo + saldoCalculado
            : currentAccount.saldo - saldoCalculado;

        // Verificamos límites
        if (debCred === "C" && saldoFinal > currentAccount.topeMax) {
          this.alertValidateCurrent = true;
          this.messageAlertValidate.push(
            `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y excede el límite máximo permitido de ${currentAccount.topeMax}.`,
          );
          this.payloadToSave = licencia;
          return false;
        } else if (debCred === "D" && saldoFinal < currentAccount.topeMin) {
          this.alertValidateCurrent = true;
          this.messageAlertValidate.push(
            `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y está por debajo del límite mínimo permitido de ${currentAccount.topeMin}.`,
          );
          this.payloadToSave = licencia;
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    handleAccept() {
      this.finalizeProcess(this.payloadToSave);
    },
    cancelValidate() {
      this.alertValidateCurrent = false;
      this.messageAlertValidate = [];
      this.alertValidate = [];
      this.payloadToSave = null;
    },

    async openFiles(item) {
      this.isLoading = true;
      try {
        await activities.dispatch("getFiles", item);
        this.showSeeFiles = true;
      } catch (error) {
        console.error("Error fetching files:", error);
        this.color = "#FF8D58";
        this.alert = true;
        this.textAlert = error.response.data.error.message;
      } finally {
        this.isLoading = false;
      }
    },
    async approvedAll() {
      // Verifica si hay al menos un elemento con tipoProceso igual a "Autorización de extras"
      const hasAuthorizationExtras = activities.state.itemsSelected.some(
        (item) => item.tipoProceso == "Autorizacíon de extras",
      );
      if (hasAuthorizationExtras) {
        if (this.getComents.length > 0) {
          this.showDialogComent = true;
          return; // Detiene el flujo hasta que el usuario seleccione un comentario
        } else {
          //no hay comentarios si o si debe ser libre
          this.isFreeComment = true;
          this.showDialogComent = true;
          return; // Detiene el flujo hasta que el usuario ingrese comentario
        }
      }

      this.processApproval();
    },

    async processApproval() {
      this.isLoading = true;
      let items = activities.state.itemsSelected;

      items.forEach((e, index) => {
        if (typeof e.cantAut === "string") {
          items[index].cantAut = this.changeHourForValue(e.cantAut);
          items[index].cantLiq = this.changeHourForValue(e.cantLiq);
          items[index].cantNoAut = this.changeHourForValue(e.cantNoAut);
        }
        items[index].approved = this.flagApproved ? 1 : 0;
        items[index].tipoProceso = this.changeType(e.tipoProceso);

        if (items[index].tipoProceso === "HSEX") {
          items[index].comentario = this.isFreeComment
            ? this.coment
            : this.selectedComent.comentario;
        }

        if (
          items[index].tipoProceso === "HSEX" &&
          items[index].approved === 1
        ) {
          if (items[index].cantAut === 0 && items[index].cantNoAut === 0) {
            items[index].cantAut = items[index].cantLiq;
            items[index].cantNoAut = undefined;
          }
        } else {
          items[index].cantAut = undefined;
          items[index].cantLiq = undefined;
          items[index].cantNoAut = undefined;
        }
      });

      activities.commit("setNewActivities", items);

      try {
        await activities.dispatch("newActivities");
        this.alert = true;
        this.color = "#82A1D0";
        await activities.dispatch("getActivities");
        this.textAlert = this.$tc("workflow.changeSuccess");
      } catch (error) {
        console.log(error);
        this.color = "#FF8D58";
        this.alert = true;
        this.textAlert = error.response.data.error.message;
      }
      this.cancel();
      this.isLoading = false;
      activities.commit("setItemsSelected", []);
      this.flagApproved = false;
      this.selectedComent = this.getComents[0].comentario
        ? this.getComents[0]
        : null;
    },
    continueComent() {
      this.alertCurrentAccoun = true;
      this.showDialogComent = false;
      this.processApproval();
    },

    openDeprecated(item) {
      this.data = {
        cantNoAut: item.cantNoAut,
        cantAut: item.cantAut,
        process: item.proceso,
        tipoProceso: this.changeType(item.tipoProceso),
        date: item.enLaFecha,
        employees: item.empleado,
        cantLiq: item.cantLiq,
        movimId: parseInt(item.movimId, 10),
        approved: 0,
      };

      if (item.tipoProceso == "Autorizacíon de extras") {
        this.showTimeDetail = true;
      } else {
        this.changeValues();
      }
    },
    allUndo() {
      this.isLoading = true;
      let items = activities.state.itemsSelected;
      items.map((e, index) => {
        items[index].movimId = e.movimId;
      });
      this.undo(items);
    },
    openUndo(item) {
      const payload = {
        movimId: item.movimId,
      };
      this.undo(payload);
    },
    undo(payload) {
      if (!payload.length) {
        activities.commit("setUndo", [payload]);
      } else {
        activities.commit("setUndo", payload);
      }
      this.isLoading = true;
      activities
        .dispatch("undo")
        .then(async () => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("workflow.undoSuccess");
          this.isLoading = false;
          await activities.dispatch("getActivities");
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          console.log(e);
          this.isLoading = false;
          this.textAlert = e.response.data.error.message;
        });
      activities.commit("setItemsSelected", []);
    },
    cancel() {
      this.showTimeDetail = false;
      this.showDialogComent = false;
      this.selectedComent = this.getComents[0].comentario
        ? this.getComents[0]
        : null;
      this.coment = "";
      this.isFreeComment = false;
      this.cancelValidate();
    },
    validate() {
      let limit =
        parseFloat(this.authorizedData) + parseFloat(this.noAuthoData);
      if (limit > this.cantLiq) {
        this.error = true;
        this.alertValidate.push(this.$tc("information.exceedsLimit"));
        setTimeout(() => {
          this.error = !this.error;
        }, 3000);
      } else if (
        !(
          this.changeHourForValue(this.data.cantCC) +
            this.authorizedData +
            this.noAuthoData <=
          this.cantLiq
        )
      ) {
        let alert = this.alertValidate.find(
          (item) => item === this.$tc("workflow.alertCantCC"),
        );
        if (!alert) {
          this.alertValidate.push(this.$tc("workflow.alertCantCC"));
        }
        this.error = true;
      } else {
        this.newActivities();
      }
    },
    newActivities() {
      this.isLoading = true;
      let payload = {
        cantNoAut: this.noAuthoData,
        cantAut: this.authorizedData,
        process: this.data.process,
        tipoProceso: this.data.tipoProceso,
        date: moment(this.data.inTheDate).format("DD-MM-YYYY"),
        employees: this.data.employees,
        cantLiq: this.cantLiq,
        movimId: this.data.movimId,
        approved: this.data.approved,
        comentario: this.isFreeComment
          ? this.coment
          : this.selectedComent.comentario,
      };
      if (this.data.cantCC !== "00:00") {
        payload.cantCC = this.changeHourForValue(this.data.cantCC);
      }
      activities.commit("setNewActivities", [payload]);
      activities
        .dispatch("newActivities")
        .then(async () => {
          this.alert = true;
          this.color = "#82A1D0";
          this.isLoading = false;
          if (this.data.approved == 0) {
            this.textAlert = this.$tc("workflow.rejectSuccess");
          } else {
            this.textAlert = this.$tc("workflow.approvedSuccess");
          }

          await activities.dispatch("getActivities");
          this.selectedComent = this.getComents[0].comentario
            ? this.getComents[0]
            : null;
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          console.log(e);
          this.isLoading = false;
          this.textAlert = e.response.data.error.message;
        });
      this.cancel();
      this.showTimeDetail = false;
      this.alert = false;
    },
    changeHourForValue(value) {
      let hours = value.slice(0, 2);
      let min = value.slice(3, 5);
      const hourValue = 60;
      return parseFloat(hours * hourValue) + parseFloat(min);
    },
    formatValueForHour(minutes) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `${String(hours).padStart(2, "0")}:${String(
        remainingMinutes,
      ).padStart(2, "0")}`;
    },
    updateCantNoAut() {
      const cantLiqMinutes = this.changeHourForValue(this.data.cantLiq);
      const cantAutMinutes = this.changeHourForValue(this.data.cantAut);
      const cantNoAutMinutes = cantLiqMinutes - cantAutMinutes;
      this.data.cantNoAut = this.formatValueForHour(cantNoAutMinutes);
    },
    changeValues() {
      this.authorizedData = this.changeHourForValue(this.data.cantAut);
      this.noAuthoData = this.changeHourForValue(this.data.cantNoAut);
      this.cantLiq = this.changeHourForValue(this.data.cantLiq);
      this.validate();
    },
    changeType(param) {
      switch (param) {
        case "Pedido de licencia":
          return "LICE";
        case "Cambio de horario":
          return "CHOR";
        case "Delegación de mando":
          return "DELE";
        case "Fichada en licencia":
          return "LICF";
        case "Autorizacíon de extras":
          return "HSEX";
        default:
          break;
      }
    },
    showFile(base64String) {
      this.fileBase64 = base64String; // Asignar el base64 completo
      this.showDocs = true; // Mostrar el diálogo
    },
    // Método para cerrar el diálogo
    closeDialog() {
      this.showDocs = false;
      this.fileBase64 = "";
    },
    closeDialogFiles() {
      this.showSeeFiles = false;
    },
    async openDialog(type, item) {
      this.typeForm = type;
      this.formKey++;
      switch (this.typeForm) {
        case "files":
          this.showFile(item.files);
          break;
        default:
          break;
      }
    },

    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headersFiles;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleFiles,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
  },
};
</script>

<style scoped>
.file-viewer {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Asegura que el contenido se ajuste al contenedor */
}

.container-refresh {
  display: flex;
  justify-content: flex-end;
  height: 50px;
}

.filter__container {
  border-radius: 10px;
  border: 1px solid #384b6d;
  margin-left: 10px !important;
}

::v-deep .mi-tabla ::v-deep th.text-start {
  background-color: #82a1d0 !important;
}

.container__actions {
  display: flex;
  justify-content: flex-end;
  margin: -15px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.btn__actions:hover {
  background-color: #82a1d0 !important;
  color: #1d3861 !important;
}

.btn__actions {
  border-radius: 20px !important;
}

.container {
  margin: 0px;
  min-width: 100%;
}

.container__btnexit {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 50px;
}

.container__check {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.bt-saveFilter {
  border-radius: 20px !important;
  color: white !important;
  background-color: #39537a !important;
}

.container__btns {
  display: flex;
  justify-content: flex-end;
  justify-items: flex-end;
  align-items: flex-end;
}

.check__ac {
  /* height: 103px !important; */
  display: flex !important;
  flex-direction: column !important;
}
.hover-effect:hover .hover-icon {
  color: #39537a; /* Azul de Vuetify */
  transform: scale(1.2); /* Aumenta ligeramente el tamaño */
  transition: all 0.2s ease-in-out;
}
</style>
